import WebBookingControlType = Infospeed.Services.ClassWeb.API.Contracts.COT.WebBookingControlType;
import SelectOptionModel = Infospeed.Services.ClassWeb.API.Contracts.COT.SelectOptionModel;

import {
    Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, Directive, Provider, forwardRef,
    DoCheck, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ControlContainer, NgForm } from '@angular/forms';
import { BaseWidgetComponent } from '../base-widget.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { Observable } from 'rxjs';
import { MatOption, MatSelect } from '@angular/material';
import { CotErrorStateMatcher } from '../../services/cot-error-state-matcher';
import { CheckedValidator, hasCheckedValidator } from '../../services/checked-validator';

//const noop = () => { };
//export const CUSTOM_VALUE_ACCESSOR: any = {
//  provide: NG_VALUE_ACCESSOR,
//  useExisting: forwardRef(() => CotFormControlComponent),
//  multi: true
//};

@Component({
    selector: 'cot-form-control',
    templateUrl: './cot-form-control.component.html',
    styleUrls: ['./cot-form-control.component.scss'],
    //providers: [CUSTOM_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CotFormControlComponent extends BaseWidgetComponent implements OnInit, OnChanges, AfterViewInit
//, ControlValueAccessor
{
    // constants
    //EMAIL_REGEX: string = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    EMAIL_REGEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    PHONENUMBER_REGEX: string = "^[\+]?[0-9]{5,15}$";
    MONEY_REGEX: string = "^[0-9]+([\.\,][0-9]{1,2})?$";
    // input
    @Input('placeholder') placeholder: string = "";
    @Input('required') required: boolean = false;
    @Input('isMobileDevice') isMobileDevice: boolean = false;
    @Input('showError') showError: boolean = true;
    @Input('controlType') controlType: WebBookingControlType = WebBookingControlType.Text;
    @Input('options') options: string[] = [];
    @Input('id') id: number | string;
    @Input('hasAdditionalInfo') hasAdditionalInfo: boolean = true;
    @Input('additionalInfoPlaceholder') additionalInfoPlaceholder: string = "Please add further details";
    @Input('form') form: NgForm;
    @Input('value') value: any;
    @Input('disabled') disabled: boolean = false;
    @Input('touchedActivatedError') touchedActivatedError: boolean = false;
    // output
    @Output('onChange') onChange: EventEmitter<ICotControlChangeEvent> = new EventEmitter<ICotControlChangeEvent>();
    // private properties
    //private innerValue: any = null; //The internal data model
    //Placeholders for the callbacks which are later provided by the Control Value Accessor
    //private onTouchedCallback: () => void = noop;
    //private onChangeCallback: (_: any) => void = noop;
    // public properties
    formControlType: string = "text";
    additionalInfo: string = null;
    errorStateMatcher: CotErrorStateMatcher;// = new CotErrorStateMatcher();

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        if (this.hasAdditionalInfo)
            this.additionalInfo = "";
        // determine control type
        switch (this.controlType) {
            case WebBookingControlType.CheckBox:
                this.formControlType = 'checkbox';
                break;
            case WebBookingControlType.Date:
                this.formControlType = 'date';
                break;
            case WebBookingControlType.DateTime:
                this.formControlType = 'datetime';
                break;
            case WebBookingControlType.Dropdown:
                this.formControlType = 'dropdown';
                break;
            case WebBookingControlType.Email:
                this.formControlType = 'email';
                break;
            case WebBookingControlType.Number:
                this.formControlType = 'number';
                break;
            case WebBookingControlType.PhoneNumber:
                this.formControlType = 'phone-number';
                break;
            case WebBookingControlType.Money:
                this.formControlType = 'money';
                break;
            case WebBookingControlType.RadioButton:
                this.formControlType = 'radiobutton';
                break;
            case WebBookingControlType.RadioButtonSimple:
                this.formControlType = 'radiobutton-simple';
                break;
            case WebBookingControlType.Text:
                this.formControlType = 'text';
                break;
            case WebBookingControlType.TextArea:
                this.formControlType = 'textarea';
                break;
            case WebBookingControlType.Time:
                this.formControlType = 'time';
                break;
            default:
                this.formControlType = 'text';
                break;
        }
        // error-state-matcher
        this.errorStateMatcher = new CotErrorStateMatcher(this.touchedActivatedError);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.required && this.form && this.form.controls[this.id]) {
                switch (this.controlType) {
                    case WebBookingControlType.CheckBox:
                        this.form.controls[this.id].setValidators([CheckedValidator(true)]);
                        this.form.controls[this.id].setValue(false);
                        break;
                }
            }
        });
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) { // model reference changes
        for (let propName in changes) {
            let changedProp = changes[propName];
            if (propName === 'options') {
                //this.value = null;
                if (this.form && this.form.controls[this.id])
                    this.form.controls[this.id].reset();
                if (this.options && this.options.length == 1) { // TODO: pre-select option when only there is only one
                    //this.value = this.options[0];
                    //this.formControl.setValue(this.options[0]);
                    //this.formControl.markAsTouched();
                    //this.formControl.updateValueAndValidity();
                }
            }
        }
    }

    ngDoCheck() { // property of the model changes
        //if (this.innerValue !== this.value) {
        //  this.changeDetectorRef.markForCheck();
        //  this.innerValue = this.value;
        //}
        ////if (this.model != this.value)
        ////  this.changeDetectorRef.markForCheck();
        ////  this.value = this.model;
    }

    //get value(): any { return this.innerValue; }; //get accessor
    //set value(val: any) {
    //  if (val !== this.innerValue) {
    //    this.innerValue = val;
    //    this.onChangeCallback(val);
    //  }
    //} //set accessor including call the onchange callback

    onCheckboxChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onDateChange($event) {
        // date correction
        if (this.value) {
            if (this.value instanceof Date) {
                let dateVar = <Date>this.value;
                let timezoneOffset = dateVar.getTimezoneOffset() * 60 * 1000;
                if (timezoneOffset < 0 && dateVar.getHours() == 0)
                    dateVar.setTime(dateVar.getTime() + Math.abs(timezoneOffset));
                else if (timezoneOffset > 0 && dateVar.getHours() == 0)
                    dateVar.setTime(dateVar.getTime() - Math.abs(timezoneOffset));
                this.value = dateVar;
            }
        }
        this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo });
    }

    onEmailChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onPhoneNumberChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onMoneyChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onNumberChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onSelectionChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }) };

    onRadioChange($event) {
        if (this.additionalInfo && !this.value) {
            this.additionalInfo = "";
            if (this.form && this.form.controls[this.id + 'AdditionalInfo'])
                this.form.controls[this.id + 'AdditionalInfo'].reset();
        }
        this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo });
    }

    onRadioSimpleChange($event) {
        this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo });
    }

    onTextChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onTextAreaChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onTimeChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onAdditionalInfoChange($event) { this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo }); }

    onDateTimeChange($event) {
        console.error('**Timezone consideration has not yet been implemented.');
        this.onChange.emit({ Id: this.id, Type: this.controlType, Value: this.value, AdditionalInfo: this.additionalInfo });
    }

    getErrorMessage(): string {
        let errorMessage: string = "Error with the field.";
        if (this.form.controls[this.id].hasError('required')) {
            errorMessage = this.placeholder + ' is required.'
        }
        else if (this.form.controls[this.id].hasError('pattern')) {
            if (this.formControlType == 'email')
                errorMessage = this.placeholder + ' is not a valid email address.';
            else
                errorMessage = this.placeholder + ' is not in valid format.';
        }
        else if (this.form.controls[this.id].hasError('checked')) {
            errorMessage = this.placeholder + ' must be checked.';
        }
        else {
        }
        return errorMessage;
    }

    //private setDefaultValue() {
    //  if (this.value == null || this.value == undefined) {
    //    if (this.controlType == WebBookingControlType.CheckBox || this.controlType == WebBookingControlType.RadioButton) {
    //      this.value = false;
    //      //if (this.form && this.form.controls[this.id]) {
    //      //  this.form.controls[this.id].setValue(false);
    //      //  this.form.controls[this.id].updateValueAndValidity();
    //      //}
    //    }
    //  }
    //}

    public get isInvalid(): boolean {
        let invalid: boolean = false;
        if (this.showError && this.form && this.form.controls[this.id] && this.form.controls[this.id].invalid) {
            invalid = true;
        }
        //else {
        //    if (this.showError && this.form && this.form.controls[this.id]) {
        //        if (hasCheckedValidator(this.form.controls[this.id]) && !this.form.controls[this.id].value)
        //            invalid = true;
        //    }
        //}
        return invalid;
    }

    public getStatus(): string {
        let status: string = "";
        if (this.form && this.form.controls[this.id]) {
            status += "value: " + this.form.controls[this.id].value;
            status += ", touched: " + this.form.controls[this.id].touched;
        }
        return status;
    }

    public setDisable(disable: boolean): void {
        if (disable)
            this.form.controls[this.id].disable();
        else
            this.form.controls[this.id].enable();
    }

    // ControlValueAccessor -> methods
    //writeValue(value: any): void {
    //  if (value !== this.innerValue)
    //    this.innerValue = value;
    //}
    //registerOnChange(fn: any): void { this.onChangeCallback = fn; }
    //registerOnTouched(fn: any): void { this.onTouchedCallback = fn; }
    //setDisabledState?(isDisabled: boolean): void { }
}

export interface ICotControlChangeEvent {
    Id: number | string;
    Type: WebBookingControlType;
    Value: any;
    AdditionalInfo: string;
}

//class Guid {
//  public static newGuid() {
//    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
//      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
//      return v.toString(16);
//    });
//  }

//  public static get empty(): string {
//    return '00000000-0000-0000-0000-000000000000';
//  }

//  public get empty(): string {
//    return Guid.empty;
//  }

//  public static isValid(str: string): boolean {
//    const validRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
//    return validRegex.test(str);
//  }

//  private value: string = this.empty;

//  constructor(value?: string) {
//    if (value) {
//      if (Guid.isValid(value)) {
//        this.value = value;
//      }
//    }
//  }

//  public toString() {
//    return this.value;
//  }

//  public toJSON(): string {
//    return this.value;
//  }
//}

//// disableControl directive
//@Directive({
//  selector: '[disableControl]'
//})
//export class DisableControlDirective {
//  @Input() set disableControl(condition: boolean) {
//    const action = condition ? 'disable' : 'enable';
//    this.ngControl.control[action]();
//  }
//  constructor(private ngControl: NgControl) {
//  }
//}



// WEBPACK FOOTER //
// ./src/app/widgets/cot-form-control/cot-form-control.component.ts